import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ECFForwarding from './ECFForwarding'
import request from 'superagent';

// TODO: use Redux
class ECFForwardingContainer extends Component {
  static propTypes = {
    casefolder_nid: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    // State is given to <ScheduleEF> as props
    this.state = {
      loading: true,
    }
  }

  render() {
    if (this.state.error) return <button onClick={() => this.fetchSettings() }>Reload ECF Notification Settings</button>;

    return <ECFForwarding
      { ...this.state  }
      permissions={ this.props.permissions }
      onSaveSettings={ value => { this.onSaveSettings(value) }  }
    />
  }


  componentDidMount() {
    this.fetchSettings();
  }

  fetchSettings() {
    console.log(`Fetching ECF Settings For ${this.props.casefolder_nid}`);

    const component = this;

    component.setState({
      error: false,
      loading: true,
    });

    const {casefolder_nid} = this.props;

    return request
      .get(`/rpc/case-folders/${casefolder_nid}/ecf-forwarding-settings`)
      .then(
        function onSuccess(response) {
          console.debug("fetchSettings", response.body);
          if (response.status !== 200) {
            return onFailure(response.message || 'service error');
          }

          component.setState({
            loading: false,
            settings: response.body,
          });
        },
        function onFailure(errorMessage) {
          console.log("onFailure", arguments);

          component.setState({
            loading: false,
            error: true,
          });

          // extract useful message if possible
          try {
            errorMessage = errorMessage.response.body.error.errorMessage
          }
          catch (and_ignore) {
          }

          alert(`Error Loading!\n\n${errorMessage}`);
        }
      );
  }


  onSaveSettings(values) {
    console.log('New Values', values);

    const component = this;

    component.setState({
      ...component.state,
      loading: true,
      settings: { data: values }, // don't lose values in case of error
    });


    function onSuccess(response) {
      console.log("onSuccess", arguments);
      if (response.status !== 200) {
        return onFailure(response.message || 'service error');
      }

      component.setState({
        ...component.state,
        loading: false,
        settings: response.body, // server will provide new version of schedule
      });
    }

    function onFailure(errorMessage) {
      console.log("onFailure", arguments);
      component.setState({
        ...component.state,
        loading: false,
      });
      // extract useful message if possible
      try {
        errorMessage = errorMessage.response.body.error.errorMessage
      }
      catch (and_ignore) {
      }

      alert(`Error Saving!\n\n${errorMessage}`);
    }

    const {casefolder_nid} = this.props;

    return request
      .post(`/rpc/case-folders/${casefolder_nid}/ecf-forwarding-settings`)
      .send({
        settings: values
      })
      .then(onSuccess, onFailure);
  }

}


export default ECFForwardingContainer;



// WEBPACK FOOTER //
// ./src/CaseFolder/Settings/ECFForwardingContainer.jsx